/**
 * Модель для работы с камерами
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';

import { IId, ICoordXY, ICamera } from './types';
import CamerasService, { IUpdateOrCreateBody } from '../services/CamerasService';

interface IState {
  item: ICamera | null;
  coordinates: ICoordXY | null;
  cameraEdit: ICamera | null;
}

const initialState: IState = {
  item: null,
  coordinates: null,
  cameraEdit: null
};

export const infrastructureCameras = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setItem(state: IState, payload: ICamera): IState {
      return { ...state, item: payload };
    },

    setItemEdit(state: IState, payload: ICamera | null | undefined): IState {
      return { ...state, cameraEdit: payload ?? null };
    },

    setCoordinates(state: IState, payload: any): IState {
      return { ...state, coordinates: payload as ICoordXY };
    },
    reset(): IState {
      return initialState;
    }
  },
  effects: (dispatch: any) => ({
    async getItem(id: IId) {
      const { data } = await CamerasService.get(id);
      this.setItem(data);
    },
    async updateOrCreate(body: IUpdateOrCreateBody) {
      try {
        await CamerasService.updateOrCreate(body);
      } catch (error) {
        return error;
      }
    },
    async remove(id: IId) {
      try {
        await CamerasService.remove(id);
      } catch (error) {
        return error;
      }
    },
    focus(center: ICoordXY) {
      const payload = { center };
      dispatch.infrastructureMap.setFocus(payload);
    }
  })
});
